// React
import { useState } from "react";

// OpenLayers
import OlMap from "ol/Map";

// Tools
import { assetURL, getFlagAssetName } from "lib/utilities/asset";

// Models
import Locale from "lib/interfaces/locale";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";

const LocalesPopup = new Popup({
	title: () => getLocaleString("locales"),
	distinct: true,
	render: function() {
		const map:OlMap = this.get("map");
		const mapConfig:any = map.get("opus-config");
		const locales:Locale[] = mapConfig.locales;
		const activeLocale:Locale = _config.lang.locale;
		const win:any = window;
		
		const [currentLocale, setCurrentLocale] = useState<Locale>(activeLocale);
			
		// On new map config loaded for new locale
		_events.on("new-map-config", () => {
			_ui.closePopupOf(this); // Hide locale selector
			_ui.hideLoading(); // Hide loading
		});
		
		const selectLocale = (locale:Locale) => {
			if(locale == currentLocale) {
				_ui.closePopupOf(this);
				return;
			}
			
			_ui.showLoading();
			_config.setLangAndLocale(locale);
		}
		const drawOptions = () => {
			const rows:Array<any> = [];
			const codesDone:string[] = [];
			
			locales.forEach((locale:Locale) => {
				if(codesDone.includes(locale.code))
					return;
				
				const flagAsset:string = getFlagAssetName(locale.code);
				
				let className:string = "unit-option";
				
				if(locale.code == _config.languageId)
					className += ` unit-option--selected ${_ui.getSelClassName()}`;
				
				codesDone.push(locale.code);
				
				rows.push(
					<div 
						className={className}
						key={locales.indexOf(locale)} 
						onClick={() => selectLocale(locale)}
					>
						<img 
							src={assetURL(`assets/images/flags/${flagAsset}.png`)} 
							className='flag'
						/>
						{locale.name}
					</div>
				);
			});
			
			return rows;
		}
		
		return (
			<>
				{drawOptions()}
			</>
		)
	}
});

export default LocalesPopup;